import { RouteRecordRaw } from 'vue-router';

import {
  useBulkGrantStore,
  useRootStore,
} from '@/store';

// 一括付与関連
export const bulkGrantRoutes: Array<RouteRecordRaw> = [
  {
    name: 'BulkGrant',
    component: () => import('@/components/pages/bulk-grant/index.vue'),
    path: '/bulk-grant',
    meta: {
      title: '一括付与',
      requiredAuthority: 'BULK_GRANTS',
    },
  },
  {
    name: 'BulkGrantId',
    component: () => import('@/components/pages/bulk-grant/detail/index.vue'),
    path: '/bulk-grant/:id',
    meta: {
      title: '一括付与詳細',
      requiredAuthority: 'BULK_GRANTS',
    },
  },
  {
    name: 'BulkGrantAdd',
    component: () => import('@/components/pages/bulk-grant/add/index.vue'),
    path: '/bulk-grant/add',
    meta: {
      title: '一括付与予約',
      requiredAuthority: 'RESERVE_BULK_GRANTS',
    },
    beforeEnter: (_, from, next) => {
    // 確認画面以外から遷移した場合は一括付与予約の状態管理を初期化
      if (from.path === '/bulk-grant/add/confirm') {
        next();
      } else {
        useBulkGrantStore().$reset();
        useRootStore().$reset();
        next();
      }
    },
  },
  {
    name: 'BulkGrantAddConfirm',
    component: () => import('@/components/pages/bulk-grant/add/confirm/index.vue'),
    path: '/bulk-grant/add/confirm',
    meta: {
      title: '一括付与予約確認',
      requiredAuthority: 'RESERVE_BULK_GRANTS',
    },
    beforeEnter: (_, from, next) => {
    // 確認画面以外から遷移した場合は登録画面に飛ばす
      if (from.path === '/bulk-grant/add') {
        next();
      } else {
        next({ path: '/bulk-grant/add', replace: true });
      }
    },
  },
];
